module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5R6bG"))).then(() => parcelRequire('9Lwss'));